import React, { ReactNode } from 'react';

import NavigationCenterTools from 'leash/components/navigationCenterTools/NavigationCenterTools';
import { Layout } from 'shared/components/layout/Layout';

interface Props {
  children: ReactNode;
}

function LeashLayout(props: Props) {
  const { children } = props;

  return <Layout navigationCenterTools={<NavigationCenterTools />}>{children}</Layout>;
}

export default LeashLayout;
